import { Role } from 'auth';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import CommunicationsWorkspace from '@/modules/admin-dashboard/components/communications/CommunicationsWorkspace.tsx';
import { PageLayout } from 'ui';

const Communications = () => {
  return (
    <PageLayout title="Communication" contentClassName="!p-0">
      <CommunicationsWorkspace />
    </PageLayout>
  );
};

export default withPrivateAccess(Communications, Role.COMPLIANCE_ADMIN);
